export enum OfficeTnCTypeEnum {
  OFFICE_TNC_PERM = 'office_tnc_perm',
}
